import brand from "./theme";

const DEFAULT_FEATURES = {
  medications: true,
  pathologies: true,
};

export function brandFeatures() {
  return { ...DEFAULT_FEATURES, ...(brand.features || {}) };
}

export function isBrandFeatureEnabled(key) {
  return brandFeatures()[key] !== false;
}
